"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["JOB"] = "job";
    EntityType["TRADER"] = "trader";
    EntityType["COMPANY"] = "company";
    EntityType["AGENCY"] = "agency";
    EntityType["DEPLOYMENT"] = "deployment";
    EntityType["JOB_OFFER"] = "job_offer";
    EntityType["CUSTOMER"] = "customer";
    EntityType["ORDER"] = "order";
    EntityType["PRODUCT"] = "product";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
//# sourceMappingURL=entity.js.map